import type { GtmBrainDoc } from "../api/GtmApi";

export type PillarListItem = {
  key: string;
  index: number;
  doc: GtmBrainDoc;
  label: string;
  filled: number;
  total: number;
};

function hasText(value?: string | null): boolean {
  return !!value && value.trim().length > 0;
}

export function pillarFill(doc: GtmBrainDoc): { filled: number; total: number } {
  const checks = [hasText(doc.pain), hasText(doc.valueProposition), hasText(doc.proof)];
  return { filled: checks.filter(Boolean).length, total: checks.length };
}

export function pillarLabel(doc: GtmBrainDoc, index: number): string {
  const pain = (doc.pain || "").trim();
  if (pain) return pain.length > 72 ? `${pain.slice(0, 69)}…` : pain;
  const name = (doc.name || "").trim();
  if (name) return name;
  return `Pillar ${index + 1}`;
}

/** Stable key — keep in sync with brainToFlow docLeaves ids. */
export function pillarKey(doc: GtmBrainDoc, pillarIndex: number): string {
  return doc.id || `doc-pillar-${pillarIndex}`;
}

export function listPillars(docs: GtmBrainDoc[]): PillarListItem[] {
  const pillarsOnly = docs
    .map((doc, index) => ({ doc, index }))
    .filter(({ doc }) => doc.docType === "pillar");
  return pillarsOnly.map(({ doc, index }, pillarIndex) => {
    const fill = pillarFill(doc);
    return {
      key: pillarKey(doc, pillarIndex),
      index,
      doc,
      label: pillarLabel(doc, pillarIndex),
      filled: fill.filled,
      total: fill.total,
    };
  });
}

export function pillarSections(doc: GtmBrainDoc): Array<{ id: string; label: string; body: string }> {
  return [
    { id: "pain", label: "Pain", body: doc.pain || "" },
    { id: "valueProposition", label: "Your answer", body: doc.valueProposition || "" },
    { id: "proof", label: "Proof", body: doc.proof || "" },
  ];
}
